const applyVisibility = ( visible ) => {
  if ( typeof window.zE === 'undefined' ) return false;

  if ( visible ) {
    window.zE( 'messenger', 'show' );
  } else {
    window.zE( 'messenger', 'hide' );
  }

  return true;
};

const setVisibility = ( visible ) => {
  if ( applyVisibility( visible )) return;

  const checkInterval = setInterval(() => {
    if ( applyVisibility( visible )) {
      clearInterval( checkInterval );
    }
  }, 200 );

  setTimeout(() => clearInterval( checkInterval ), 10000 );
};

export default {
  setVisibility,
};
